import {Component, OnInit, Injector, ElementRef, ViewChild, AfterViewInit, HostListener, OnChanges, SimpleChanges} from '@angular/core';
import {NgbModal, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {tradeskOrdersTabComponent, Ticket} from '../tradedeskTabs/orders/tradeskOrdersTab/tradeskOrdersTab.component';
import {DataService} from '../../services/data/data.service';
import {OrderCellRendererComponent} from '../tradedeskTabs/orders/orderCellRendererComponent.component';
import {ColDef, RowNode} from 'ag-grid';
import {OrderPipsCellRenderer} from '../tradedeskTabs/orders/orderPipsCellRenderer.component';
import {OrderPnlCellRenderer} from '../tradedeskTabs/orders/orderPnlCellRenderer.component';
import {ShowOrderDeleteModal} from '../modals/orderdelete/orderdelete.component';
import {ShowOrderDeleteMobileModal} from '../modals/mobile-order-delete/mobile-order-delete.component';
import {orderTypeCellRenderer} from '../tradedeskTabs/orders/orderTypeCellRenderer.component';
import * as $ from "jquery";
import {chartLinesService} from '../../services/chartLinesService';
@Component({
  selector: 'mobile-trade-desk-orders-tab',
  template: require('./mobile-trade-desk-orders-tab.component.html'),
  styles: [require('./mobile-trade-desk-orders-tab.component.css')]
})
export class MobileTradeDeskOrdersTabComponent extends tradeskOrdersTabComponent implements AfterViewInit {

  @ViewChild("balanceContainer") public balanceContainer!: ElementRef;

  hideFooter = false;

  public set selectedTicked(v: string) {
    this._selectedTicked = v;
    this.hideFooter = false;
  }

  public getRowHeight(params: any) {
    //  var rowIsDetailRow = params.node.level === 1;
    // return 100 when detail row, otherwise return 25
    console.log(params);
    return 40;
  }

  constructor(injector: Injector, private _tradeLinesVisibilityService:chartLinesService,  protected elRef: ElementRef, public dataService: DataService, protected ngbModalService: NgbModal, public parserFormatter: NgbDateParserFormatter) {
    super(injector, _tradeLinesVisibilityService, elRef, dataService, ngbModalService, parserFormatter);
    this.gridOptions.headerHeight = 40;
    this.gridOptions.rowBuffer = 1000000;
    this.setColumnDefs();
    setInterval(() => {
      if(!!this.selectedRow && $("ag-grid-angular").find("div[id='appender']").length < 1)
        this.appendDataDiv(this.selectedRow.id, this.selectedRow.data);
    }, 0)
  }

  editTicket() {
    super.editTicket();
    this.hideFooter = true;
  }

  partialCloseTicket() {
    super.partialCloseTicket();
  //  this.hideFooter = true;
  }

  ngAfterViewInit() {
    //   if(this.workspace.mobileMode!="desktop")
    //   {
    if(this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
    this.hideButtonsActionSubscriber()
    //   }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    if(this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  
  public redraw(e:any)
  {
    if(this.gridOptions && this.gridOptions.api)
    this.gridOptions.api.redrawRows()
  }


  columnDefs: ColDef[] = [];

  public get balanceContainerHeight(): any {
    return this.balanceContainer.nativeElement.offsetHeight || 0;
  }


  public get calculateHeight() {
    return {
      height: 'calc( 100% - ' + (this.balanceContainerHeight) + 'px )'
    }

  }


  public get currentTradeTabId()
  {
    return this.workspace.activeOrderTab
  }

  //this.gridApi.getRowNode(index).setSelected(true);

  buildColumnDefs(): ColDef[] {
    const columnDefs = [
      //  {headerName: 'Id', field: 'id', filter: "agNumberColumnFilter"},
      // {headerName: 'Status', field: 'status', filter: "agTextColumnFilter" },
      {
        headerName: "Symbol",
        field: "Symbol",
        filter: "agTextColumnFilter",
        cellStyle: {"text-align": "left", "font-size": "16px !important", "line-height": this.getRowHeight("") + 'px !important'},
        width: 110,
        minWidth: 110,
        // maxWidth: 220,
        // suppressDragLeaveHidesColumns:true
      },
      {
        headerName: "Type",
        cellRendererFramework: orderTypeCellRenderer,
        field: "Type",
        filter: "agTextColumnFilter",
        cellStyle: {"text-align": "left", "font-size": "16px !important", "line-height": this.getRowHeight("") + 'px !important'},
        width: 110,
        minWidth: 110,
        // maxWidth: 220
      },
      {
        headerName: this.pending ? "Distance" : "Pips",
        cellRendererFramework: OrderPipsCellRenderer,
        filter: "agNumberColumnFilter",
        cellStyle: {"text-align": "left", "font-size": "16px !important", "line-height": this.getRowHeight("") + 'px !important'},
        width: 80,
        minWidth: 80,

        field: "Pips",
        comparator: this.valComparator
      },
    ];

    if(!this.pending) {
      columnDefs.push(
        {
          headerName: "UPL",
          cellRendererFramework: OrderPnlCellRenderer,
          filter: "agTextColumnFilter",
          cellStyle: {"text-align": "left", "font-size": "16px !important", "line-height": this.getRowHeight("") + 'px !important'},
          width: 110,
          minWidth: 110,
          // maxWidth: 220,
          field: "PnLUSD",
          comparator: this.valUPLComparator
        } as any)
    }
    return columnDefs;
  }

  get isSelectedRow()
  {
    if(this.gridApi&&this.workspace.mobileMode!="desktop")
    {
         let l = this.gridApi.getSelectedRows();
        if(l.length==0)
        {
          return false;
        }
        else
        {
          return true;
        }
         return true
    }
    return false;
  }



  public onSelectionChanged(e: any) {
    this.registerMenu();
    if(this.gridApi !== undefined) {
      let row = this.gridApi.getDisplayedRowAtIndex(e.rowIndex);
      if(row && row.data) {

        this.selectedOrder = row.data;

        if(this.selectedOrder !== undefined) {
          this.isEditable = (this.selectedOrder.MenuRequests.indexOf("EditRq") > -1) ? true : false;
          this.isCloseable = (this.selectedOrder.MenuRequests.indexOf("CloseReq") > -1) ? true : false;
          this.isCancelable = (this.selectedOrder.MenuRequests.indexOf("CancelReq") > -1) ? true : false;
        }

        this.selectedTicked = row.data.Ticket;

        //  this.selectedChart.loadOrderData(row.data);


      }



    }

  }

  public lastSelectedIndex: string | undefined = undefined;

  private collapsedHeight: number = 40
  private expandedHeight: number = 180

  selectedRow?: RowNode;
  public onRowClick(e: any) {

    if(this.gridApi !== undefined) {

      // console.log(this.selectedTicked);

      let row = this.gridApi.getDisplayedRowAtIndex(e.rowIndex);
      if(this.lastSelectedIndex != row.id) {

        if(this.lastSelectedIndex !== undefined) {
          let rowNode = this.gridApi.getRowNode(this.lastSelectedIndex);
          if(rowNode !== undefined) {
            rowNode.setRowHeight(this.collapsedHeight);
          }
        }



        this.updateChartTradeLinesData()
        this.lastSelectedIndex = row.id;
        this.workspace.lastSelectedRowData = e;
        let rowNode = this.gridApi.getRowNode(row.id);
        rowNode.setRowHeight(this.expandedHeight);
        this.selectedRow = row;
        this.appendDataDiv(row.id, row.data);
        //  rowNode.expanded 
        // if(this.selectedOrder!==undefined)
        // {
        //   this.selectedTicked = this.selectedOrder.Ticket; 
        //   console.log(this.selectedTicked)
        // }

      }
      else {
      //  this.gridApi.deselectAll();
        console.log("ALEREADY SELECTED");
        if(this.lastSelectedIndex !== undefined) {
          //  this.gridApi.getRowNode(this.lastSelectedIndex).setSelected(false);
          this.gridApi.deselectAll();
          this.gridApi.clearFocusedCell();
          this.updateChartTradeLinesData();
          this.selectedTicked = "";

          let rowNode = this.gridApi.getRowNode(this.lastSelectedIndex);

          if(rowNode !== undefined) {
            rowNode.setRowHeight(this.collapsedHeight);
          }


          $("ag-grid-angular").find("div[id='appender']").remove();
          this.selectedRow = undefined;

          this.lastSelectedIndex = undefined;
          this.selectedOrder = undefined;
          this.workspace.lastSelectedRowData = null;
        }

      }
    }
  }

  public appendDataDiv(rowId: any, rowData: any) {

    $("ag-grid-angular").find("div[id='appender']").remove();
    let html = this.getDetailsHtml(rowData);
    $("ag-grid-angular").find("div[row-id='" + rowId + "']").append("<div class='appendable' id='appender'>" + html + "</div>");
  }

  public getDetailsHtml(data: any) {
    let pt = "pt-3";
    if(this.workspace.currentProvider == "OANDA") {
      pt = "pt-2";
    }

    let width = screen.width - 20;
    let html = "<div style='width:" + width + "px' class='apendposfixed'>";
    html += "<div class='text-center p-1 pt-3'>Entry Time " + data.EntryTime + "</div>";
    html += "<div class='row m-0 pt-4'><div class='col-6 p-0'>" + this.getDetailRowComponent("Ticket", String(data.Ticket)) + "</div><div class='col-6 p-0'>" + this.getDetailRowComponent("Qty", String(data.Qty)) + "</div></div>";
    html += "<div class='row m-0 " + pt + "'><div class='col-6 p-0'>" + this.getDetailRowComponent("Entry Price", String(data.EntryPrice)) + "</div><div class='col-6 p-0'>" + this.getDetailRowComponent("Stop", String(data.Stop)) + "</div></div>";
    html += "<div class='row m-0 " + pt + "'><div class='col-6 p-0'>" + this.getDetailRowComponent("Market Price", String(data.MarketPrice)) + "</div><div class='col-6 p-0'>" + this.getDetailRowComponent("Limit", String(data.Limit)) + "</div></div>";
    if(this.workspace.currentProvider == "OANDA") {
      html += "<div class='row m-0 " + pt + "'><div class='col-6 p-0'> </div><div class='col-6 p-0'>" + this.getDetailRowComponent("TS", String(data.Trailing)) + "</div></div>";
    }

    html += "<div>";
    return html;
  }

  public getDetailRowComponent(label: string, value: string) {
    value = value != "null" ? value : "NA";
    let html = "<div class='row m-0 p-0'><div class='col-6 text-left'>" + label + "</div><div class='col-6 text-right'>" + value + "</div></div>"
    return html
  }





  setColumnDefs() {
    const columnDefs = this.buildColumnDefs();
    for(let i = 0; i < columnDefs.length; i++) {
      const colDef = columnDefs[i];

      if(colDef.cellRendererFramework == OrderCellRendererComponent)
        colDef.maxWidth = colDef.width = colDef.maxWidth = 60;

      if(colDef.headerName == 'Ticket')
        colDef.width = colDef.minWidth = 90;

      if(colDef.headerName == 'Entry Time')
        colDef.width = colDef.minWidth = 200;

      if(colDef.headerName == 'Entry Price')
        colDef.width = colDef.minWidth = 130;

      if(colDef.headerName == 'Market Price')
        colDef.width = colDef.minWidth = 150;

      if(colDef.headerName == 'UPL')
        colDef.width = colDef.minWidth = 130;


      this.setCellStyle(colDef);
    }
    this.columnDefs = columnDefs;
  }

  setCellStyle(columnDef: any) {
    columnDef.cellStyle = Object.assign(columnDef.cellStyle || {},
      {
        'font-size': '16px !important',
        'line-height': this.getRowHeight("") + 'px !important',
        'text-align': 'left'
      });
  }

  public registerMenu() {

  }


  public showDeleteModal() {
  
    if(this.selectedOrder !== undefined) {
   
      let selectedSymbol = this.selectedOrder.Symbol;
      let selectedQty = this.selectedOrder.Qty;

      let selectedOrderWithQty = this.latestBySymbolAndQuantity.filter(v => {
        return v.symbol == selectedSymbol && v.qty == selectedQty
      });

      

      ShowOrderDeleteMobileModal(this.ngbModalService, this.selectedOrder, selectedOrderWithQty[0].ticketId).finally(()=>{
        console.log("CLOSEMOBILE");
       // this.globaGridMode.mobileOrderButtonState.unsubscribe()
      });
      
    }
  }


  public hideButtonsActionSubscriber()
  {
    this.globaGridMode.mobileOrderButtonState.subscribe(v=>{
      
      
      if(this.lastSelectedIndex !== undefined) {
      
        if( this.gridApi && this.selectedOrder==undefined)
        {
          this.gridApi.deselectAll();
          this.gridApi.clearFocusedCell();
          this.updateChartTradeLinesData();
          this.selectedTicked = "";

          let rowNode = this.gridApi.getRowNode(this.lastSelectedIndex);

          if(rowNode !== undefined) {
            rowNode.setRowHeight(this.collapsedHeight);
          }


          $("ag-grid-angular").find("div[id='appender']").remove();
          this.selectedRow = undefined;

          this.lastSelectedIndex = undefined;
          this.selectedOrder = undefined;
          this.workspace.lastSelectedRowData = null;
      }
        this.selectedOrder = undefined;
      }


    })
  }





  // public closeTicket() {

  //   if(this.selectedOrder !== undefined) {
  //     console.log("this.selectedOrder.Ticket");
  //     console.log(this.selectedOrder.Ticket);



  //     let ticketData: Ticket = {Ticket: this.selectedOrder.Ticket};

  //     this.dataService.sendRequest({Cmd: DataService.TYPE_CLOSETRADE, Data: ticketData});
  //   }


  // }

  public cancelTicket() {
    if(this.selectedOrder !== undefined) {
    
      let ticketData: Ticket = {Ticket: this.selectedOrder.Ticket};

      this.dataService.sendRequest({Cmd: DataService.TYPE_CANCELTRADE, Data: ticketData});
      this.selectedOrder = undefined
    }
  }

}
